import { PageController } from '@client/components/_core/layout/PageController';
import { IncidentFlagEdit } from '@client/components/incidents/IncidentFlagEdit';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/console/$orgId/configuration/compliance/incidents/flags/edit/$incidentFlagId')({
    params: {
        parse({ incidentFlagId }) {
            return {
                incidentFlagId: BigInt(incidentFlagId),
            };
        },
    },
    staticData: {
        presentation: 'overlay',
        metadata: {
            title: 'Edit flag',
        },
    },
    component: RouteComponent,
});

function RouteComponent() {
    return (
        <PageController route={Route}>
            <IncidentFlagEdit action={['edit', Route.useParams().incidentFlagId]} />
        </PageController>
    );
}
